module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/video/Flyer-78036a1b7fb7739e68a461662b84273d.mp4";